import { TypedActionWithPayload } from '@/types/redux';

export const LIVE_ASK_CHANGED = 'LIVE_ASK_CHANGED';
export const LIVE_AUCTION_ENDED = 'LIVE_AUCTION_ENDED';
export const LIVE_AUCTION_LOADED = 'LIVE_AUCTION_LOADED';
export type LIVE_AUCTION_LOADED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_LOADED,
    { catalogId: number; created: number; serverId: number }
>;
export const LIVE_AUCTION_MOVED = 'LIVE_AUCTION_MOVED';
export const LIVE_AUCTION_OPENED = 'LIVE_AUCTION_OPENED';
export type LIVE_AUCTION_OPENED_ACTION = TypedActionWithPayload<
    typeof LIVE_AUCTION_OPENED,
    { catalogId: number; created: number; serverId: number }
>;
export const LIVE_AUCTION_PAUSED = 'LIVE_AUCTION_PAUSED';
export const LIVE_AUCTION_RESUMED = 'LIVE_AUCTION_RESUMED';
export const LIVE_AUCTION_STARTED = 'LIVE_AUCTION_STARTED';
export const LIVE_BID_ACCEPTED = 'LIVE_BID_ACCEPTED';
export const LIVE_BID_RETRACTED = 'LIVE_BID_RETRACTED';
export const LIVE_LOT_CLOSED = 'LIVE_LOT_CLOSED';
export const LIVE_LOT_PASSED = 'LIVE_LOT_PASSED';
export const LIVE_LOT_REOPENED = 'LIVE_LOT_REOPENED';
export const LIVE_LOT_SKIPPED = 'LIVE_LOT_SKIPPED';
export const LIVE_LOT_SOLD = 'LIVE_LOT_SOLD';
export const LIVE_LOT_UNSOLD = 'LIVE_LOT_UNSOLD';
export const LIVE_MISSIVE = 'LIVE_MISSIVE';
export const LIVE_NETWORK_DISCONNECTED = 'LIVE_NETWORK_DISCONNECTED';
export const LIVE_NETWORK_RECONNECTED = 'LIVE_NETWORK_RECONNECTED';
export const LIVE_NEXT_LOT_LOADED = 'LIVE_NEXT_LOT_LOADED';
export const LIVE_NEXT_LOT_OPENED = 'LIVE_NEXT_LOT_OPENED';

export const LIVE_UPDATE_ACTIVE_BIDDERS_PUBNUB = 'LIVE_UPDATE_ACTIVE_BIDDERS_PUBNUB';
export const LIVE_UPDATE_ACTIVE_BIDDERS_SFS = 'LIVE_UPDATE_ACTIVE_BIDDERS_SFS';

export const LIVE_UPDATE_TIMESTAMP = 'LIVE_UPDATE_TIMESTAMP';
